import {takeEvery} from 'redux-saga/effects'
import {
  LOAD_FORM_DATA,
  LOAD_MAPPINGS,
  UPDATE_FORM_DATA,
} from 'setup/redux/Actions/CustomNames/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(LOAD_FORM_DATA, fetchData)
  yield takeEvery(UPDATE_FORM_DATA, fetchData)
  yield takeEvery(LOAD_MAPPINGS, fetchData)
}

export default dataSaga
